import React, {Component} from 'react';
import { BrowserRouter as  Router, Link  } from 'react-router-dom';
import { firebaseAuth,ref,storage} from '../../config/constants'

class Header extends Component {
    constructor(){
        super();
        this.logOut = this.logOut.bind(this);
        this.toggleMenu = this.toggleMenu.bind(this);

        this.state = {
            userId : "",
            user : {},
            path : "",
            quotationCount : 0,
            display : "togglehide"
        }
        
    }
    componentWillMount() {

        this.listener = firebaseAuth().onAuthStateChanged(user=>{
            if (user){
                var db = ref.child("users").child(user.uid);
                    db.on("value",function(data){
                      
                        this.setState({
                            userId:data.key,
                            user:data.val()
                        });
                        let image = data.val().image
                        storage.child("Admin").child(image).getDownloadURL().then(function(url){
                            this.setState({
                            path : url
                            })
                        }.bind(this))
                    }.bind(this));                
            }else{
               window.location = "/login";
            }

        });

        let quotation = ref.child("Quotation").orderByChild('status').equalTo('Pending');
            quotation.on("value", function(snap){
                var count= 0 ;
                snap.forEach(function(){
                    count++
                    this.setState({
                    quotationCount : count
                        })
                 }.bind(this))
                
            }.bind(this))

        
       
    }
    componentDidUpdate(prevProps,prevState){
        if(prevState.user!==this.state.user){
            if(this.state.user.role=="Admin"){
                this.setState({
                    display:"toggleshow"
                })
                console.log(this.state.user.role)
            }else{
                 this.setState({
                    display:"togglehide"
                })
            }
            
        }
        
    }
    logOut(){
        firebaseAuth().signOut();
    }

    toggleMenu() {
        var sidemenu = document.querySelector('#page-container');
        sidemenu.classList.toggle('sidebar-visible-xs');
    }

    render() {
        
        return (
            <header className="navbar navbar-default">
                <link rel="stylesheet" href={"/" + this.state.user.dashboardColor} />
                <ul className="nav navbar-nav-custom">
                    <li>
                        <a href="javascript:void(0)" className="white" onClick={this.toggleMenu}>
                            <i className="fa fa-bars fa-fw"></i>
                        </a>
                    </li>
                </ul>
                <ul className="nav navbar-nav-custom pull-right">
                    <li className="dropdown">
                        <a href="javascript:void(0)" className="dropdown-toggle" data-toggle="dropdown">
                            <img src={this.state.path} alt="avatar"/> <i className="fa fa-angle-down"></i>
                        </a>
                        <ul className="dropdown-menu dropdown-custom dropdown-menu-right">
                            <li className="dropdown-header text-center">Account</li>
                            <li>
                                <a href="/quotation/pending" className={this.state.display}>
                                    <i className="fa fa-clock-o fa-fw pull-right"></i>
                                    <span className="badge pull-right">{this.state.quotationCount}</span>
                                    Quotation
                                </a>
                                <a href="#">
                                    <i className="fa fa-envelope-o fa-fw pull-right"></i>
                                    <span className="badge pull-right">0</span>
                                    Messages
                                </a>
                            </li>
                            <li className="divider"></li>
                            <li>
                                <Link to={`/users/${this.state.userId}/profile`}>
                                    <i className="fa fa-user fa-fw pull-right"></i>
                                    Profile
                                </Link>
                                
                                <Link to={`/users/${this.state.userId}/avatar`}>
                                    <i className="fa fa-user fa-fw pull-right"></i>
                                    Change Avatar
                                </Link>
                            </li>
                            <li className="divider"></li>
                            <li>
                                <a href="javascript:void(0)" onClick={this.logOut}><i className="fa fa-ban fa-fw pull-right"></i> Logout</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </header>
        );
    }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/inc/Header.js